/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { DestinationProviderAttributes } from '../models/DestinationProviderAttributes';
import { DestinationRestoreTypeAttributes } from '../models/DestinationRestoreTypeAttributes';
import { Provider } from '../models/Provider';
import { RestoreResult } from '../models/RestoreResult';

export class DestinationDetails {
  /**
  * Eon-assigned restore account ID.
  */
  'restoreAccountId': string;
  /**
  * Cloud-provider-assigned restore account ID.
  */
  'providerAccountId': string;
  'cloudProvider': Provider;
  /**
  * Region the data is restored to.
  */
  'region': string;
  'providerSpecificConfig'?: DestinationProviderAttributes | null;
  'typeSpecificConfig'?: DestinationRestoreTypeAttributes | null;
  'restoreResult'?: RestoreResult | null;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerAccountId",
      "baseName": "providerAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "cloudProvider",
      "baseName": "cloudProvider",
      "type": "Provider",
      "format": ""
    },
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerSpecificConfig",
      "baseName": "providerSpecificConfig",
      "type": "DestinationProviderAttributes",
      "format": ""
    },
    {
      "name": "typeSpecificConfig",
      "baseName": "typeSpecificConfig",
      "type": "DestinationRestoreTypeAttributes",
      "format": ""
    },
    {
      "name": "restoreResult",
      "baseName": "restoreResult",
      "type": "RestoreResult",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DestinationDetails.attributeTypeMap;
  }

  public constructor() {
  }
}



